import React from 'react';
import { Users, Wrench, ThumbsUp, TrendingUp } from 'lucide-react';
import { companyInfo } from '../mockData';

const About = () => {
  const stats = [
    { icon: Users, number: "50+", label: "Anni di Esperienza" },
    { icon: ThumbsUp, number: "50.000+", label: "Clienti Soddisfatti" },
    { icon: Wrench, number: "30.000+", label: "Installazioni" },
    { icon: TrendingUp, number: "100%", label: "Qualità Garantita" }
  ];

  return (
    <section id="about" className="py-20 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Images */}
          <div className="space-y-4">
            {/* Furgone - Immagine principale */}
            <div className="rounded-2xl shadow-2xl overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_italserrande/artifacts/7x0o0ts5_1000044355.jpg"
                alt="Furgone ItalSerrande - Servizio professionale a Roma"
                loading="lazy"
                decoding="async"
                className="w-full h-auto"
              />
            </div>
            
            {/* Officina - Seconda immagine */}
            <div className="rounded-2xl shadow-xl overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_italserrande/artifacts/mo9w3yn1_1000044354.jpg"
                alt="Officina ItalSerrande - Attrezzature professionali"
                loading="lazy"
                decoding="async"
                className="w-full h-auto"
              />
            </div>
          </div>

          {/* Right Column - Content */}
          <div>
            <div className="inline-block mb-4">
              <span className="bg-green-100 text-green-700 px-4 py-2 rounded-full text-sm font-semibold">
                Chi Siamo
              </span>
            </div>
            
            <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-6">
              Esperienza e Professionalità al Vostro Servizio
            </h2>
            
            <div className="space-y-4 text-lg text-gray-700 mb-8">
              <p>
                <strong className="text-slate-900">ItalSerrande SRL</strong> è un'azienda leader nel settore della sicurezza e della protezione a Roma. Con oltre 50 anni di esperienza, ci siamo affermati come punto di riferimento per serrande, tapparelle, cancelli e sistemi di automazione.
              </p>
              <p>
                Il nostro team di tecnici specializzati garantisce installazioni a regola d'arte, utilizzando solo materiali di prima qualità e tecnologie all'avanguardia. Ogni progetto è seguito con cura, dal sopralluogo iniziale fino all'assistenza post-vendita.
              </p>
              <p>
                Lavoriamo con passione e dedizione per offrire ai nostri clienti soluzioni su misura che combinano sicurezza, funzionalità ed estetica, sempre nel rispetto dei più alti standard qualitativi del Made in Italy.
              </p>
            </div>

            {/* Italian Flag Accent */}
            <div className="flex gap-2 mb-8">
              <div className="w-20 h-2 bg-green-600 rounded-full"></div>
              <div className="w-20 h-2 bg-gray-200 rounded-full"></div>
              <div className="w-20 h-2 bg-red-600 rounded-full"></div>
            </div>

            {/* Stats */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {stats.map((stat, index) => {
                const Icon = stat.icon;
                return (
                  <div key={index} className="text-center">
                    <div className="bg-green-100 w-12 h-12 rounded-lg flex items-center justify-center mx-auto mb-3">
                      <Icon className="text-green-600" size={24} />
                    </div>
                    <div className="text-3xl font-bold text-slate-900 mb-1">{stat.number}</div>
                    <div className="text-sm text-gray-600">{stat.label}</div>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
